module.exports = __webpack_public_path__ + "static/media/collect-data-centralization.28fbf897.png";